<div class="height-bar p-2 mx-1">
  <div class="flex justify-content-between">
    <h3 class="mt-0">{{ 'map.filters.height' | translate }}</h3>
  </div>
  <div class="slider p-2 flex justify-content-end">
    <p-slider
      [disabled]="disabled"
      [(ngModel)]="heightRange"
      [range]="true"
      orientation="vertical"
      [min]="0"
      [max]="alititudeArray.length - 1"
      [step]="1"
      [style]="windowSize().height <= 800 ? { height: '25rem' } : { height: '32rem' }"
      (onChange)="onHeightRangeChange($event)"
      (onSlideEnd)="onHeightRangeChangeComplete()"
    />
    <div class="relative">
      <div class="slider-tooltip" [style.bottom.%]="tooltipPositionMin" [style.transform]="'translateY(+50%)'">
        {{ minHeight }}
      </div>
      <div class="slider-tooltip" [style.bottom.%]="tooltipPositionMax" [style.transform]="'translateY(+50%)'">
        {{ maxHeight }}
      </div>
    </div>
  </div>
</div>
